/*
 * 给 TeamPhotoPicker 子组件(PhotosList / HeaderExtra)用的 Context,
 * 让"已选照片来源"和"过滤规则"等 aiClerk 特化项可以从顶层注入,
 * 子组件不需要再独立读 redux photoPicker。
 */
import { createContext, useContext } from 'react'

export interface TeamPhotoPickerCtxValue {
  /** 当前 picker 之外、已经被其他地方占用的照片,会被列表 filter 排除 */
  excludePhotos: any[]
  /**
   * 是否放宽过滤规则:
   *   - false: 跟批量编辑添加照片完全一致 — 只显示 hasWatermark + 有防伪码 +
   *           watermarkBaseID!='21' 的照片
   *   - true:  全量显示团队照片(只过滤已选 + 视频),aiClerk 选图场景默认
   */
  relaxFilter: boolean
  /**
   * 单次最多可选数量。 0 / undefined = 不限制。
   * 子组件 PhotosList 用它在用户点击照片时即时拦截(已 >= maxCount 就 toast),
   * 跟 root 的 handleConfirm 兜底拦截配合,避免 "用户选超了才在'完成'时报错"
   * 的尴尬体验。
   */
  maxCount?: number
}

const DEFAULT_CTX: TeamPhotoPickerCtxValue = {
  excludePhotos: [],
  relaxFilter: false,
  maxCount: undefined
}

export const TeamPhotoPickerContext =
  createContext<TeamPhotoPickerCtxValue>(DEFAULT_CTX)

export const useTeamPhotoPickerCtx = (): TeamPhotoPickerCtxValue =>
  useContext(TeamPhotoPickerContext)
